var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
define('areas/home/parts/loadnavigation',["require", "exports", "common/parts", "services/httpclient", "services/settings"], function (require, exports, Parts, Http, Settings) {
    "use strict";
    var LoadNavigation = (function (_super) {
        __extends(LoadNavigation, _super);
        function LoadNavigation() {
            _super.apply(this, arguments);
        }
        LoadNavigation.prototype.process = function (symbol) {
            var _this = this;
            var service = new Http.Channel();
            service.getDataAsync("/activation/api/configuration/navigation/mine?showAAATile=" +
                (Settings.Settings.environment.userManager.aaaConfiguration.isAAAEnabled && !Settings.Settings.environment.userManager.aaaConfiguration.isSSOEnabled), Http.ServiceTarget.oneClickServiceApi)
                .then(function (response) {
                _this.output.call(response);
            })
                .fail(function (error) {
                _this.error.call(error);
            });
        };
        return LoadNavigation;
    }(Parts.Part));
    return LoadNavigation;
});

